import { render } from "./location-collection.vue?vue&type=template&id=93f8e6c0"
import script from "./location-collection.vue?vue&type=script&lang=js"
export * from "./location-collection.vue?vue&type=script&lang=js"

import "./location-collection.vue?vue&type=style&index=0&id=93f8e6c0&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__